import React from 'react';
import Image from '../../commonComponents/image/Image';
import { FacebookShareButton, WhatsappShareButton, InstapaperShareButton, VKShareButton, TwitterShareButton, TelegramShareButton, TwitterIcon, FacebookIcon, WhatsappIcon, InstapaperIcon, VKIcon, TelegramIcon } from 'react-share';

const FBButton = ({ url, title, shareimg }) => (
    <FacebookShareButton url={url} quote={title}>
        <FacebookIcon size={32} round className="icons--main-nav"/>
        {/* <Image className="icons--main-nav" src={shareimg} /> */}
    </FacebookShareButton>
);
const InstaButton = ({ url, title, shareimg }) => (
    <InstapaperShareButton url={url} title={title}>
        <InstapaperIcon size={32} round className="icons--main-nav" />
        {/* <Image className="icons--main-nav" src={shareimg} /> */}
    </InstapaperShareButton>
);
const TwitterButton = ({ url, title, shareimg }) => (
    <TwitterShareButton url={url} title={title}>
        <TwitterIcon size={32} round className="icons--main-nav"/>
        {/* <Image className="icons--main-nav" src={shareimg} /> */}
    </TwitterShareButton>
);

const VKButton = ({ url, title, shareimg }) => (
    <VKShareButton url={url} title={title}>
        <VKIcon size={32} round className="icons--main-nav" />
        {/* <Image className="icons--main-nav" src={shareimg} /> */}
    </VKShareButton>
);

const WhatsappButton = ({ url, title, shareimg }) => (
    <WhatsappShareButton url={url} title={title}>
        <WhatsappIcon size={32} round className="icons--main-nav"/>
        {/* <Image className="icons--main-nav" src={shareimg} /> */}
    </WhatsappShareButton>
);

const TelegramButton = ({ url, title, shareimg }) => {
    return (
        <TelegramShareButton url={url} title={title}>
            <TelegramIcon size={32} round className="icons--main-nav" />
            {/* <Image className="icons--main-nav" src={shareimg} /> */}
        </TelegramShareButton>
    );
};

export { FBButton, InstaButton, TwitterButton, WhatsappButton, VKButton, TelegramButton }

